import { Button, Checkbox, Grid, Typography } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { resourceDeAllocationMultiple } from 'src/services/projectService';
import { AppActions } from 'src/store/AppReducer';

const DeAllocateForm = ({
  deAllocateData,
  toggle,
  getData,
  setSnackBarOpen,
  setSnackBarMessage,
  setSnackbarSeverity,
  setCheckedUsers,
  setDeallocateUsers
}) => {
  const LabelStyle = {
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: '13px'
  };

  const [initialAllocationData, setInitialAllocationData] = useState<any>([]);
  const dispatch = useDispatch();
  useEffect(() => {
    setInitialAllocationData(deAllocateData);
  }, [deAllocateData]);

  const [deallocationIDS, setDeallocationIDS] = useState<any>([]);

  const onDeAllocate = () => {
    if (deallocationIDS.length > 0) {
      dispatch(AppActions.showLoader());

      resourceDeAllocationMultiple(deallocationIDS)
        .then(() => {
          setSnackBarMessage('You’ve deallocated the resource successfully.');
          setSnackbarSeverity('success');
          setSnackBarOpen(true);
          getData();
          toggle();
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          setSnackBarMessage(
            'Unable to update the resource allocation details'
          );
          setSnackbarSeverity('error');
          setSnackBarOpen(true);
          dispatch(AppActions.hideLoader());
        });
    }
  };

  const onClose = () => {
    setCheckedUsers([]);
    setDeallocateUsers([]);
    toggle();
  };

  return (
    <Fragment>
      <Grid sx={{ px: 2, mt: '0.5rem' }} container spacing={2}>
        <Grid item xs={6}>
          <Typography
            sx={{ pb: 1 }}
            variant="h4"
            style={{
              paddingLeft: 10,
              paddingRight: 10,
              fontSize: '15px'
            }}
          >
            Deallocate
          </Typography>
        </Grid>
      </Grid>
      <Grid sx={{ px: 2 }} container spacing={2}>
        {initialAllocationData.length > 0 &&
          initialAllocationData.map((allo) => (
            <Fragment key={allo.employeeId}>
              <Grid item xs={12}>
                <Typography variant="h5" style={LabelStyle}>
                  {allo.name}
                </Typography>
              </Grid>
              {allo.allocations.length > 0 ? (
                allo.allocations.map((singleAllo) => (
                  <Grid
                    item
                    xs={6}
                    display="flex"
                    alignItems="center"
                    style={{ paddingTop: '0.5rem' }}
                  >
                    <Checkbox
                      checked={deallocationIDS.includes(singleAllo.id)}
                      color="primary"
                      onChange={(e) => {
                        if (!e.target.checked) {
                          setDeallocationIDS(
                            deallocationIDS.filter(
                              (fil) => fil !== singleAllo.id
                            )
                          );
                        } else {
                          setDeallocationIDS([
                            ...deallocationIDS,
                            singleAllo?.id
                          ]);
                        }
                      }}
                    />
                    <Typography
                      style={{ fontSize: '12px', fontWeight: 'bold' }}
                      color="GrayText"
                    >
                      {`${singleAllo.projectName}`}&nbsp;&nbsp;&nbsp;
                      {`Allocation: ${singleAllo.allocation}%`}
                    </Typography>
                  </Grid>
                ))
              ) : (
                <Grid
                  item
                  xs={12}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography
                    style={{ fontSize: '12px', fontWeight: 'bold' }}
                    color="GrayText"
                  >
                    No Allocations for this employee
                  </Typography>
                </Grid>
              )}
            </Fragment>
          ))}
      </Grid>
      <Grid
        item
        sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}
        xs={12}
      >
        <Button
          size="small"
          sx={{
            width: '10%',
            background: '#F5F7FF',
            fontSize: '13px',
            fontWeight: 'normal'
          }}
          onClick={() => onClose()}
        >
          Cancel
        </Button>
        <Button
          size="small"
          sx={{
            width: '16%',
            ml: 3,
            fontSize: '13px',
            fontWeight: 'normal',
            background: '#0069E4'
          }}
          variant="contained"
          type="button"
          onClick={() => onDeAllocate()}
        >
          Deallocate
        </Button>
      </Grid>
    </Fragment>
  );
};

export default DeAllocateForm;
